import _asyncToGenerator from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6b29118e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "align-self-stretch pt-1"
};
var _hoisted_2 = {
  class: "flex-fill"
};
var _hoisted_3 = {
  class: "mb-2"
};
var _hoisted_4 = {
  class: "d-flex flex-row align-items-center"
};
var _hoisted_5 = {
  class: "me-2"
};

var _hoisted_6 = /*#__PURE__*/_createTextVNode(" Public ");

var _hoisted_7 = {
  key: 0
};

var _hoisted_8 = /*#__PURE__*/_createTextVNode(" In ");

var _hoisted_9 = {
  class: "details mt-3"
};
var _hoisted_10 = {
  class: "detail"
};
var _hoisted_11 = {
  class: "detail"
};
import { computed } from "vue";
import { useRouter } from "vue-router";
import { DateTime } from "luxon";
import { LockOpenOutline, ShareSocialOutline } from "@vicons/ionicons5";
import { UseTimeAgo } from "@vueuse/components";
import { useIsMobile } from "@/utils/reactive";
import Avatar from "@/components/users/Avatar.vue";
import MessageSourcesAction from "@/components/messages/MessageSourcesAction.vue";
export default /*#__PURE__*/_defineComponent({
  props: {
    message: null,
    maxLines: null,
    link: {
      type: Boolean,
      default: true
    },
    showGroups: {
      type: Boolean,
      default: true
    },
    showPublic: {
      type: Boolean,
      default: false
    },
    group: null
  },
  setup: function setup(__props) {
    var props = __props;
    var router = useRouter();
    var isMobile = useIsMobile();
    var creationDate = computed(function () {
      return DateTime.fromISO(props.message.creationDate, {
        zone: "UTC"
      });
    });
    var sources = computed(function () {
      return props.message.sources || [];
    });
    var hasGroups = computed(function () {
      return !!props.message.groups && props.message.groups.length > 0 || !!props.group;
    });
    var hasPublicLabel = computed(function () {
      return props.message.isPublic && hasGroups.value;
    });

    var view = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (props.link) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return router.push({
                  name: "Message",
                  query: {
                    k: props.message.key
                  }
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function view() {
        return _ref.apply(this, arguments);
      };
    }();

    var toGroup = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return router.push({
                  name: "Group",
                  params: {
                    id: id
                  }
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function toGroup(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    return function (_ctx, _cache) {
      var _component_n_text = _resolveComponent("n-text");

      var _component_n_tag = _resolveComponent("n-tag");

      var _component_n_ellipsis = _resolveComponent("n-ellipsis");

      var _component_n_p = _resolveComponent("n-p");

      var _component_n_icon = _resolveComponent("n-icon");

      var _component_n_button = _resolveComponent("n-button");

      var _component_n_tooltip = _resolveComponent("n-tooltip");

      var _component_n_card = _resolveComponent("n-card");

      return _openBlock(), _createBlock(_component_n_card, {
        class: _normalizeClass(["message-item rounded-2", {
          'link': __props.link
        }]),
        bordered: false,
        embedded: "",
        onClick: view
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createVNode(Avatar, {
            user: __props.message.createdByUser,
            size: 42,
            class: "me-3"
          }, null, 8, ["user"])]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("strong", null, _toDisplayString(__props.message.createdByUser.userName), 1)]), _createElementVNode("div", null, [_createElementVNode("small", null, [_createVNode(_unref(UseTimeAgo), {
            time: _unref(creationDate).toJSDate()
          }, {
            default: _withCtx(function (_ref3) {
              var timeAgo = _ref3.timeAgo;
              return [_createVNode(_component_n_text, {
                depth: "3"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(timeAgo), 1)];
                }),
                _: 2
              }, 1024)];
            }),
            _: 1
          }, 8, ["time"])])]), _createElementVNode("div", null, [__props.showPublic && _unref(hasPublicLabel) ? (_openBlock(), _createBlock(_component_n_tag, {
            key: 0,
            size: "small",
            class: "rounded-2 message-tag ms-2"
          }, {
            default: _withCtx(function () {
              return [_hoisted_6];
            }),
            _: 1
          })) : _createCommentVNode("", true)])]), __props.showGroups && _unref(hasGroups) ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("small", null, [_hoisted_8, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.message.groups, function (group) {
            return _openBlock(), _createBlock(_component_n_text, {
              key: group.groupId,
              type: "primary",
              underline: "",
              onClick: _withModifiers(function ($event) {
                return toGroup(group.groupId);
              }, ["stop"])
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(group.name), 1)];
              }),
              _: 2
            }, 1032, ["onClick"]);
          }), 128))])])) : _createCommentVNode("", true)]), _createVNode(_component_n_p, {
            class: "content m-0"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_n_text, {
                depth: "2"
              }, {
                default: _withCtx(function () {
                  return [__props.maxLines ? (_openBlock(), _createBlock(_component_n_ellipsis, {
                    key: 0,
                    "line-clamp": __props.maxLines,
                    tooltip: false
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(__props.message.content), 1)];
                    }),
                    _: 1
                  }, 8, ["line-clamp"])) : (_openBlock(), _createElementBlock(_Fragment, {
                    key: 1
                  }, [_createTextVNode(_toDisplayString(__props.message.content), 1)], 64))];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_n_tooltip, {
            trigger: "hover",
            placement: "bottom-start",
            disabled: _unref(isMobile)
          }, {
            trigger: _withCtx(function () {
              return [_createVNode(_component_n_button, {
                quaternary: "",
                size: "tiny",
                disabled: ""
              }, {
                icon: _withCtx(function () {
                  return [_createVNode(_component_n_icon, null, {
                    default: _withCtx(function () {
                      return [_createVNode(_unref(LockOpenOutline))];
                    }),
                    _: 1
                  })];
                }),
                default: _withCtx(function () {
                  return [_createTextVNode(" " + _toDisplayString(__props.message.nbParse), 1)];
                }),
                _: 1
              })];
            }),
            default: _withCtx(function () {
              return [_createTextVNode(" This message has been decoded " + _toDisplayString(__props.message.nbParse) + " times ", 1)];
            }),
            _: 1
          }, 8, ["disabled"])]), _createElementVNode("div", _hoisted_11, [_createVNode(MessageSourcesAction, {
            mkey: __props.message.key,
            loaded: __props.message.sources
          }, {
            action: _withCtx(function (_ref4) {
              var trigger = _ref4.trigger;
              return [_createVNode(_component_n_tooltip, {
                trigger: "hover",
                placement: "bottom-start",
                disabled: _unref(isMobile)
              }, {
                trigger: _withCtx(function () {
                  return [_createVNode(_component_n_button, {
                    quaternary: "",
                    type: "info",
                    size: "tiny",
                    class: "action",
                    onClick: _withModifiers(trigger, ["stop"])
                  }, {
                    icon: _withCtx(function () {
                      return [_createVNode(_component_n_icon, null, {
                        default: _withCtx(function () {
                          return [_createVNode(_unref(ShareSocialOutline))];
                        }),
                        _: 1
                      })];
                    }),
                    default: _withCtx(function () {
                      return [_createTextVNode(" " + _toDisplayString(_unref(sources).length || 0), 1)];
                    }),
                    _: 2
                  }, 1032, ["onClick"])];
                }),
                default: _withCtx(function () {
                  return [_createTextVNode(" This message has been seen on " + _toDisplayString(_unref(sources).length) + " pages ", 1)];
                }),
                _: 2
              }, 1032, ["disabled"])];
            }),
            _: 1
          }, 8, ["mkey", "loaded"])])])])];
        }),
        _: 1
      }, 8, ["class"]);
    };
  }
});